import {Component, Input, OnInit, ChangeDetectorRef, Renderer2, ElementRef} from '@angular/core';
import {properties} from './../../../../environments/properties';
import {SubscriptionService} from "../../../shared/services/subscription.service";

@Component({
    selector: 'message-center',
    templateUrl: './message-center.component.html',
    styleUrls: ['./message-center.component.scss']
})
export class MessageCenterComponent implements OnInit {

    freshPassConfig;
    @Input() userSubscriptionDetails;
    @Input() userInfo;
    @Input() currentEnvironment;
    showMessage = false;
    message: string;
    isDefaultMsg: boolean;
    isVerifiedPromoMsg: boolean = false;

    constructor(public subscriptionService: SubscriptionService,
      private cdr: ChangeDetectorRef,
      private renderer: Renderer2,
      private el: ElementRef
    ) {
    }

    ngOnInit() {
        this.freshPassConfig = properties;
        this.initSubscribes();
    }

    initSubscribes() {
        this.subscriptionService.messageCenterData$.subscribe((data) => {
            if (data && data.value && data.value.length > 0) {
                
                if (data.isVerifiedPromoMessage) {
                    this.isVerifiedPromoMsg = true;
                } else {
                  this.isDefaultMsg = data.isErrorMsg ? false : true;
                }

                this.showMessage = true;
                this.message = data.value;
            } else {
                this.message = '';
                this.showMessage = false;
            }
            setTimeout(() => {
              this.cdr.detectChanges();
              this.addStylesToVerificationLink();
            }, 0);
        });
    }

    addStylesToVerificationLink() {
      const verificationLink = this.el.nativeElement.querySelector('.verificationLink');
      if (verificationLink) {
        this.renderer.setStyle(verificationLink, 'text-decoration', 'underline');
      }
    }
}

